import React from 'react';
import "./Map.css";

import { ReactComponent as MapSvg } from '../assets/svg/map.svg';


function Map({ points, current, onClick }) {
	const handleClick = (id) => {
		if (onClick) {
			onClick(id);
		}
	}

	return (
		<div className="embed embed-map">
			<div className="fading"></div>
			<MapSvg />
			{Object.entries(points).map(([id, { visited, x, y }], index) => (
				<React.Fragment key={id}>
					{ visited
					?
						<button style={{top: y+"%", left: x+"%"}} className={`embed-map-point visited${current === index + 1 ? " current" : ""}`} onClick={() => handleClick(index)}>
							<span>{index + 1}</span>
							{ current === index + 1
								? <span id="radar"></span>
								: <></>
							}
						</button>
					:
						<div className="embed-map-point" style={{top: y+"%", left: x+"%"}}><span>{index + 1}</span></div>
					}
				</React.Fragment>
			))}
		</div>
	);
}

export default Map;
